module.exports = __webpack_public_path__ + "img/full7-min.e13d95c8.png";